import Head from "next/head";

export default function SeoCollect() {
  const title = "Murfy : Dons de vos appareils électroménagers";

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta property="og:title" key="og:title" content={title} />
      </Head>
    </>
  );
}
